module.exports = __webpack_public_path__ + "static/media/yash-bhatt.06879a29.jpg";